// Variant Color Filter - Shows only images matching selected color
class VariantColorFilter {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupFilter());
    } else {
      this.setupFilter();
    }
  }

  setupFilter() {
    // Find all variant option selectors (color swatches, dropdowns, etc.)
    this.setupVariantListeners();
    
    // Initial filter after a short delay
    setTimeout(() => this.filterBySelectedVariant(), 300);
  }

  setupVariantListeners() {
    // Listen for changes on variant option inputs
    const variantInputs = document.querySelectorAll(
      '.product-form__input input[type="radio"], ' +
      '.product-form__input select, ' +
      '.variant-selector input, ' +
      '.variant-selector select'
    );
    
    variantInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        // Small delay to let the variant selection complete
        setTimeout(() => this.filterBySelectedVariant(), 100);
      });
    });

    // Also listen for the hidden variant input change (if your theme uses it)
    const hiddenVariantInput = document.querySelector('input[name="id"]');
    if (hiddenVariantInput) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            this.filterBySelectedVariant();
          }
        });
      });
      
      observer.observe(hiddenVariantInput, { attributes: true });
    }
  }

  filterBySelectedVariant() {
    // Get all media items
    const mediaItems = document.querySelectorAll('.product__media-item');
    const thumbnailItems = document.querySelectorAll('.thumbnail-list__item');
    
    // Find the selected variant's color/option
    const selectedColor = this.getSelectedVariantColor();
    
    if (!selectedColor) {
      // If no color selected, show all non-variant images
      this.showAllNonVariantMedia(mediaItems, thumbnailItems);
      return;
    }

    // Count visible items for debugging
    let visibleCount = 0;
    let hiddenCount = 0;

    // Filter main gallery images
    mediaItems.forEach(item => {
      const mediaGroup = item.getAttribute('data-media-group');
      
      if (!mediaGroup || mediaGroup === '') {
        // This is a general product image (not tied to any variant) - SHOW IT
        item.style.display = '';
        item.classList.remove('hidden-media');
        visibleCount++;
      } else if (mediaGroup.toLowerCase() === selectedColor.toLowerCase()) {
        // This image matches the selected color - SHOW IT
        item.style.display = '';
        item.classList.remove('hidden-media');
        visibleCount++;
      } else {
        // This image is for a different color - HIDE IT
        item.style.display = 'none';
        item.classList.add('hidden-media');
        hiddenCount++;
      }
    });

    // Filter thumbnails the same way
    thumbnailItems.forEach(item => {
      const mediaGroup = item.getAttribute('data-media-group');
      
      if (!mediaGroup || mediaGroup === '') {
        item.style.display = '';
        item.classList.remove('hidden-thumbnail');
      } else if (mediaGroup.toLowerCase() === selectedColor.toLowerCase()) {
        item.style.display = '';
        item.classList.remove('hidden-thumbnail');
      } else {
        item.style.display = 'none';
        item.classList.add('hidden-thumbnail');
      }
    });

    // Update the active slide
    this.updateActiveSlide();

    // Log for debugging
    console.log(`Color filter: "${selectedColor}" - Showing ${visibleCount} images, hiding ${hiddenCount} images`);
  }

  getSelectedVariantColor() {
    // Try to find the selected color from variant options
    
    // Method 1: Look for color swatch inputs that are checked
    const colorInputs = document.querySelectorAll(
      '.product-form__input input[type="radio"]:checked, ' +
      '.variant-selector input[type="radio"]:checked'
    );
    
    for (let input of colorInputs) {
      // Get the value from the input
      const value = input.value;
      if (value) {
        return value;
      }
      
      // Or get from the label text
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        return label.textContent.trim();
      }
    }
    
    // Method 2: Look for selected option in dropdown
    const selectInputs = document.querySelectorAll(
      '.product-form__input select, ' +
      '.variant-selector select'
    );
    
    for (let select of selectInputs) {
      if (select.selectedIndex > -1) {
        return select.options[select.selectedIndex].text;
      }
    }
    
    // Method 3: Get from the hidden variant input
    const hiddenInput = document.querySelector('input[name="id"]');
    if (hiddenInput && hiddenInput.value) {
      // This is more complex - would need to map variant ID to color
      // For now, return null and let the fallback handle it
    }
    
    return null;
  }

  showAllNonVariantMedia(mediaItems, thumbnailItems) {
    // Show only images that don't belong to any variant
    mediaItems.forEach(item => {
      const mediaGroup = item.getAttribute('data-media-group');
      if (!mediaGroup || mediaGroup === '') {
        item.style.display = '';
        item.classList.remove('hidden-media');
      } else {
        item.style.display = 'none';
        item.classList.add('hidden-media');
      }
    });

    thumbnailItems.forEach(item => {
      const mediaGroup = item.getAttribute('data-media-group');
      if (!mediaGroup || mediaGroup === '') {
        item.style.display = '';
        item.classList.remove('hidden-thumbnail');
      } else {
        item.style.display = 'none';
        item.classList.add('hidden-thumbnail');
      }
    });

    this.updateActiveSlide();
  }

  updateActiveSlide() {
    // Find the first visible media item and make it active
    const visibleItems = document.querySelectorAll('.product__media-item:not([style*="display: none"])');
    
    // Remove active class from all items
    document.querySelectorAll('.product__media-item').forEach(item => {
      item.classList.remove('is-active');
    });

    // Add active class to first visible item
    if (visibleItems.length > 0) {
      visibleItems[0].classList.add('is-active');
      
      // Update thumbnail active state
      const activeMediaId = visibleItems[0].getAttribute('data-media-id');
      document.querySelectorAll('.thumbnail-list__item').forEach(thumb => {
        const button = thumb.querySelector('button');
        if (button) {
          button.removeAttribute('aria-current');
          if (thumb.getAttribute('data-target') === activeMediaId) {
            button.setAttribute('aria-current', 'true');
          }
        }
      });
    }

    // Trigger slider update if needed
    const sliderComponent = document.querySelector('slider-component');
    if (sliderComponent && sliderComponent.update) {
      sliderComponent.update();
    }
  }
}

// Initialize the filter
new VariantColorFilter();